<script setup>
import copyright from "@/components/copyright";
import { onBeforeUnmount, onMounted, ref, computed, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";

// 基础平台icon
import basePng from "@/assets/images/entrance/base.png";
import baseHover from "@/assets/images/entrance/base-hover.png";

// 预算icon
import budget from "@/assets/images/entrance/budget.png";
import budgetHover from "@/assets/images/entrance/budget-hover.png";

// 库房icon
import storeroom from "@/assets/images/entrance/storeroom.png";
import storeroomHover from "@/assets/images/entrance/storeroom-hover.png";

// 营销icon
import marketing from "@/assets/images/entrance/marketing.png";
import marketingHover from "@/assets/images/entrance/marketing-hover.png";

// 工程icon
import project from "@/assets/images/entrance/project.png";
import projectHover from "@/assets/images/entrance/project-hover.png";

// 管网icon
import pipe from "@/assets/images/entrance/pipe.png";
import pipeHover from "@/assets/images/entrance/pipe-hover.png";

// cms icon
import cms from "@/assets/images/entrance/cms.png";
import cmsHover from "@/assets/images/entrance/cms-hover.png";

// iot icon
import iot from "@/assets/images/entrance/iot.png";
import iotHover from "@/assets/images/entrance/iot-hover.png";

// 二次供水 icon
import secondaryWaterSupply from "@/assets/images/entrance/SecondaryWaterSupply.png";
import secondaryWaterSupplyHover from "@/assets/images/entrance/SecondaryWaterSupply-hover.png";

// 厂站icon
import station from "@/assets/images/entrance/station.png";
import stationHover from "@/assets/images/entrance/station-hover.png";

// 流程中心icon
import flow from "@/assets/images/entrance/flow.png";
import flowHover from "@/assets/images/entrance/flow-hover.png";

// AI算法 icon
import AI from "@/assets/images/entrance/AI.png";
import AIHover from "@/assets/images/entrance/AI-hover.png";

// 运营平台
import operate from "@/assets/images/entrance/operate.png";
import operateHover from "@/assets/images/entrance/operate-hover.png";

// 供水大脑
import supplyBrain from "@/assets/images/entrance/supplyBrain.png";
import supplyBrainHover from "@/assets/images/entrance/supplyBrain-hover.png";

const timer = ref(null);

const store = useStore();

const router = useRouter();

// 系统列表
const systemList = ref([]);

// 当前时间
const currentTime = ref(null);

// 当前日期
const currentDate = ref(null);

// 问候语
const hello = ref("上午");

// 菜单图标映射
const menuIcons = reactive({
  "1677238071789752320": [basePng, baseHover],
  "1680784981016317952": [budget, budgetHover],
  "1683679191499186176": [storeroom, storeroomHover],
  "1684505905062125568": [marketing, marketingHover],
  "1685912754688794624": [project, projectHover],
  "1686990513326432256": [pipe, pipeHover],
  "1693503007503065088": [flow, flowHover],
  "1716630331786174464": [AI, AIHover],
  "1717004391934238720": [cms, cmsHover],
  "1719259338876821504": [iot, iotHover],
  "1722058280819662848": [operate, operateHover],
  1: [secondaryWaterSupply, secondaryWaterSupplyHover],
  supplyBrain: [supplyBrain, supplyBrainHover],
});

const userInfo = computed(() => store.getters.userInfo);

const getTime = () => {
  timer.value = setInterval(() => {
    /* 时间 */
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0"); // 补齐两位数
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    currentTime.value = `${hours}:${minutes}:${seconds}`;
  }, 1000);
};

const getDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
  const day = String(now.getDate()).padStart(2, "0");
  let hour = now.getHours();

  if (hour < 12) {
    hello.value = "上午";
  } else if (hour < 18) {
    hello.value = "下午";
  } else {
    hello.value = "晚上";
  }

  currentDate.value = `${year}年${month}月${day}日`;
};

// 获取系统列表
const getSystemList = () => {
  systemList.value = [];
  if (store.getters.userInfo) {
    if (store.getters.userInfo.menuTree.length > 0) {
      if (store.getters.userInfo.menuTree[0].menuCode == "1") {
        systemList.value = store.getters.userInfo.menuTree[0]?.children ?? [];
      } else {
        store.getters.userInfo.menuTree.forEach((item) => {
          if (item.menuCode !== "1" && item.menuType.value === "M") {
            systemList.value.push(item);
          }
        });
      }
    }
    // 二次供水 暂时隐藏
    // systemList.value.push({
    //   menuCode: 1,
    // });
    // 供水大脑
    const newItem = { menuCode: "supplyBrain", menuName: "供水大脑123" };
    const exists = systemList.value.some(
      item => item.menuCode === newItem.menuCode
    );
    if (!exists) {
      systemList.value.push(newItem);
    }
  } else {
    systemList.value = [];
  }
  systemList.value.map((i) => {
    i.isHover = 0;
  });
};

// const a = 1420;
// const b = 550;

let a = window.innerWidth * 0.74;
let b = window.innerHeight * 0.58;

const getPos = (index) => {
  a = window.document.getElementById("calc").offsetWidth;
  b = window.document.getElementById("calc").offsetHeight;
  // // 计算角度
  // 计算角度，增加 index * 0.1 的偏移量
  let angle;
  if (systemList.value.length < 5) {
    angle =
      ((2 * Math.PI) / systemList.value.length) * index +
      Math.PI / 2 +
      index * 0.2;
  } else {
    angle = ((2 * Math.PI) / systemList.value.length) * index + Math.PI / 2;
  }
  // 计算在椭圆上的位置
  const x = (a / 2) * (1 + Math.cos(angle));
  const y = (b / 2) * (1 + Math.sin(angle));

  // 判断是否是需要偏移的盒子
  if (
    systemList.value.length > 5 &&
    systemList.value.length % 2 === 0 &&
    index === Math.floor(systemList.value.length / 2)
  ) {
    // 往第一象限偏移一定的距离
    const offsetX = 150; // 设置偏移的距离
    const offsetY = 0; // 设置偏移的距离
    const newX = x + offsetX;
    const newY = y - offsetY;
    return { x: newX, y: newY };
  }
  return { x, y };
};
const handleMouseOver = (item) => {
  item.isHover = 1;
};
const handleMouseLeave = (item) => {
  item.isHover = 0;
};

/** 点击系统 */
const clickSystem = (sys) => {
  if (sys.menuCode == 1) {
    window.open("http://192.168.2.241:11111/");
    return;
  }
  if (sys.menuCode === "supplyBrain") {
    window.open("http://192.168.2.215:8080/view/1779721363516293122");
    return;
  }
  store.commit("permission/SET_SUB_SYSTEM_ID", sys.menuCode);
  sessionStorage.setItem("subSystemId", sys.menuCode);

  router.push({ path: getRouter(sys) });
};

// 根据点击的系统获取系统下的第一个菜单
const getRouter = (node) => {
  if (node.menuType.value === "C") {
    return node.frongRoute;
  } else {
    if (node.children && node.children.length > 0) {
      return getRouter(node.children[0]);
    }
  }
};

const logout = () => {
  ElMessageBox.confirm("是否退出登录？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      store.dispatch("userInfo/LogOut").then(() => {
        store.commit("permission/SET_SUB_SYSTEM_NAME", "");
        store.commit("permission/SET_ROUTE_TABS", []);
        store.commit("permission/SET_SUB_SYSTEM_ID", "");
        router.replace("/login");
      });
    })
    .catch(() => {});
};

onMounted(() => {
  getTime();
  getDate();
  getSystemList();
});

onBeforeUnmount(() => {
  /* 关闭页面销毁所有定时器 */
  clearInterval(timer.value);
});
</script>

<template>
  <div class="container">
    <div class="title">
      <div class="date-time">
        <div class="time">{{ currentTime }}</div>
        <div class="date">{{ currentDate }}</div>
      </div>
      <el-dropdown>
        <div class="welcome">
          <el-avatar
            :size="24"
            v-if="userInfo.fileVO && userInfo.fileVO.path"
            :src="userInfo.fileVO && userInfo.fileVO.path"
          ></el-avatar>
          <el-button
            type="primary"
            circle
            v-else
            style="width: 22px; height: 22px"
          >
            {{
              userInfo
                ? userInfo.nikeName
                  ? userInfo.nikeName[0]
                  : userInfo.userName[0]
                : "管"
            }}</el-button
          >
          <div class="nickname">
            {{
              `${hello}好，欢迎${
                userInfo
                  ? userInfo.nikeName
                    ? userInfo.nikeName
                    : userInfo.userName
                  : "管理员"
              }登陆`
            }}
          </div>
        </div>
        <template #dropdown>
          <el-dropdown-item @click="logout">安全退出</el-dropdown-item>
        </template>
      </el-dropdown>
    </div>
    <div class="main">
      <div class="base">
        <div class="menu" id="calc">
          <div class="slant">
            <div class="outer"></div>
            <div class="inner"></div>
            <div class="clock"></div>
            <div class="static"></div>
            <div class="over"></div>
          </div>
          <div class="mount"></div>
          <div class="fire"></div>
          <div class="brain"></div>
          <div class="union_points">
            <div
              v-for="item of 11"
              :key="item"
              :class="[`line line${item}`]"
            ></div>
          </div>
          <div class="btn-circle">
            <div
              @click="clickSystem(item)"
              class="circle-item"
              v-for="(item, index) in systemList"
              :key="item"
              :style="{
                position: 'absolute',
                transform: 'translate(-50%, -50%)',
                left: `${getPos(index).x}px`,
                top: `${getPos(index).y}px`,
              }"
              @mouseover="handleMouseOver(item)"
              @mouseleave="handleMouseLeave(item)"
            >
              <img
                :src="
                  menuIcons[item.menuCode]
                    ? menuIcons[item.menuCode][item.isHover]
                    : ''
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <copyright :isBackgroundWhite="false" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/entrance/background.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .title {
    width: 100%;
    height: 90px;
    flex-shrink: 0;
    background-image: url("../../assets/images/entrance/title_gr.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: 50%;

    color: #fff;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 20px 140px;

    .date-time {
      width: 216px;
      height: 29px;
      display: flex;
      align-items: center;
      flex-shrink: 0;

      .time {
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
      }
      .date {
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.7);
        margin-left: 10px;
      }
    }
    .welcome {
      display: inline-flex;
      gap: 8px;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      height: 40%;
      color: #fff;
      cursor: pointer;

      img {
        width: 24px;
        height: 20px;
        border-radius: 50%;
      }

      .nickname {
        font-size: 14px;
        font-weight: 400;
        margin-top: 5px;
      }
    }
  }
  .main {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 150px;
    display: flex;
    justify-content: center;

    .base {
      width: 1420px;
      height: 788.613px;
      box-sizing: border-box;
      position: relative;
      top: 20px;

      .menu {
        width: 1420px;
        height: 561px;
        background: url("../../assets/images/entrance/static-circle.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: 50%;
        position: relative;
        top: 20%;

        .slant {
          width: 100%;
          height: 100%;
          position: relative;
          perspective: 1000px;
          transform: rotateX(65deg);

          .outer {
            width: 930px;
            height: 930px;
            background: url("../../assets/images/entrance/outer.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: 50%;
            animation: rotate 18s linear infinite;
            position: absolute;
            top: -40%;
            left: 16%;
            transform: translate(-50%, -50%);
          }

          .inner {
            width: 862px;
            height: 862px;
            background: url("../../assets/images/entrance/inner.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: 50%;
            position: absolute;
            animation: rotate-n 30s linear infinite;
            top: -35%;
            left: 18.5%;
            transform: translate(-50%, -50%);
          }

          .clock {
            width: 804px;
            height: 804px;
            background: url("../../assets/images/entrance/zhong.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: 50%;
            position: absolute;
            top: -31%;
            left: 21%;
            transform: translate(-50%, -50%);
            animation: swing 2s ease-in-out infinite;
          }

          .static {
            width: 698px;
            height: 698px;
            background: url("../../assets/images/entrance/static.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: 50%;
            position: absolute;
            top: -23%;
            left: 25%;
          }

          .over {
            width: 788px;
            height: 788px;
            background: url("../../assets/images/entrance/over.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: 50%;
            position: absolute;
            top: -44%;
            left: 22%;
          }
        }
        .mount {
          width: 579px;
          height: 280px;
          background: url("../../assets/images/entrance/mount.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: 50%;
          position: absolute;
          top: 6%;
          left: 29.5%;
        }

        .fire {
          width: 390px;
          height: 215px;
          background: url("../../assets/images/entrance/fire.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: 50%;
          position: absolute;
          top: 3.6%;
          left: 36.1%;
        }

        .brain {
          width: 274px;
          height: 204px;
          background: url("../../assets/images/entrance/brain_gr.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: 50%;
          position: absolute;
          top: -15%;
          left: 40.4%;
          z-index: 2;
        }

        .btn-circle {
          width: 100%;
          height: 75%;
          position: relative;
          top: -99%;
          border-radius: 50%;

          .circle-item {
            width: 120px;
            height: 100px;
            position: absolute;
            z-index: 1;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .circle-item:hover {
            width: 128px;
            height: 146px;
          }
        }
      }
      .union_points {
        width: 292px;
        height: 215px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 39%;
        .line {
          width: 2px;
          height: 100px;
          background: linear-gradient(
            to bottom,
            rgba(42, 153, 255, 0.1) 50%,
            rgb(153, 247, 250) 0%,
            rgba(42, 153, 255, 0.1) 100%
          );
        }
        .line1 {
          animation: line1 1s linear infinite;
        }
        .line2 {
          animation: line1 0.5s 0.2s linear infinite;
        }
        .line3 {
          animation: line1 1.5s 0.5s linear infinite;
        }
        .line4 {
          animation: line1 1.3s 1s linear infinite;
        }
        .line5 {
          animation: line1 1.6s 0.3s linear infinite;
        }
        .line6 {
          animation: line1 2s 0.4s linear infinite;
        }
        .line7 {
          animation: line1 1.2s 0.6s linear infinite;
        }
        .line8 {
          animation: line1 1.1s 1.1s linear infinite;
        }
        .line9 {
          animation: line1 1.9s 0.9s linear infinite;
        }
        .line10 {
          animation: line1 1.7s 1.3s linear infinite;
        }
        .line11 {
          animation: line1 1.3s 1.1s linear infinite;
        }
        .line12 {
          animation: line1 1.4s 0.4s linear infinite;
        }
      }
      .full_points {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 110px;
        overflow: hidden;
        position: absolute;

        .line {
          width: 2px;
          height: 150px;
          background: linear-gradient(
            to bottom,
            rgb(153, 247, 250),
            rgba(42, 153, 255, 0.1)
          );
        }
        .line1 {
          animation: line1 1s linear infinite;
        }
        .line2 {
          animation: line1 0.5s 0.2s linear infinite;
        }
        .line3 {
          animation: line1 1.5s 0.5s linear infinite;
        }
        .line4 {
          animation: line1 1.3s 1s linear infinite;
        }
        .line5 {
          animation: line1 1.6s 0.3s linear infinite;
        }
        .line6 {
          animation: line1 2s 0.4s linear infinite;
        }
        .line7 {
          animation: line1 1.2s 0.6s linear infinite;
        }
        .line8 {
          animation: line1 1.1s 1.1s linear infinite;
        }
        .line9 {
          animation: line1 1.9s 0.9s linear infinite;
        }
        .line10 {
          animation: line1 1.7s 1.3s linear infinite;
        }
        .line11 {
          animation: line1 1.3s 1.1s linear infinite;
        }
        .line12 {
          animation: line1 1.4s 0.4s linear infinite;
        }
      }
    }
  }
}
@keyframes line1 {
  0% {
    transform: translateY(220px);
  }
  100% {
    transform: translateY(-220px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes rotate-n {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
}

@keyframes swing {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
  }

  100% {
    transform: rotate(0deg);
  }
}
</style>
